import React from 'react';
import { Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { TextAreaBox } from 'fw/forms';
import { Label, Button } from 'fw/components';
import { DocumentUpload } from "areas/shared/controls";
import { SetupTab } from 'areas/shared/pages/setup';
import * as App from 'modules/app/App';
import * as API from 'modules/app/API';
import SystemAPI from 'fw/system/API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import * as Formatting from 'fw/misc/Formatting';
import OnlinePaymentInfoPopUp from '../../../certification/steps/companyInfo/OnlinePaymentInfoPopUp';

class ManageCompanyInfoTab extends SetupTab {

    initialForm() {
        return {
            showOnlinePaymentInfoPopUp: false
        }
    }

    onOnlinePaymentInfoClose = () => {
        this.setState({
            showOnlinePaymentInfoPopUp: false
        });
    }

    onOnlinePaymentInfoClick = () => {
        if (this.state.form.onlinePayment !== null || this.state.form.paymentInfoStorageToken === null) {
            this.setState({
                showOnlinePaymentInfoPopUp: true
            });
        }
        else if (this.state.form.paymentInfoStorageToken !== null) {
            new SystemAPI().download({
                storageToken: this.state.form.paymentInfoStorageToken,
                fileName: this.state.form.paymentInfoFileName
            });
        }
    }

    componentWillMount() {
        this.setState({
            showMinorityOwners: false,
        })
    }

    privileges() {
        return {
            edit: App.hasPrivilege("ManageVobEdit"),
        }
    }

    urls() {
        return {
            get: API.Biz.url('/vobSetup/getManageVobInfo'),
            save: API.Biz.url('/vobSetup/saveManageVobInfo')
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId
        }
    }

    saveRequest() {
        let form = this.state.form;
        return {
            certificationKey: this.props.selectedId,
            certificationId: form.certificationId,
            capabilitiesStatement: form.capabilitiesStatement,
            capabilitiesStatementStorageToken: form.capabilitiesStatementStorageToken,
            capabilitiesStatementFileName: form.capabilitiesStatementFileName,
            professionalAccreditation: form.professionalAccreditation,
            professionalAccreditationStorageToken: form.professionalAccreditationStorageToken,
            professionalAccreditationFileName: form.professionalAccreditationFileName,
            rowVersion: form.rowVersion
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    updatePostData = (form, dirty) => {
        this.setState({ form });

        if (dirty === true)
            this.dirt();
    }

    handleChangeOwnersDisplay(e) {
        e.preventDefault();
        this.setState({ showMinorityOwners: !this.state.showMinorityOwners })
    }

    handleCapabilitiesStatementUploadChange = (file) => {
        let form = this.state.form;
        form.capabilitiesStatementStorageToken = file.storageToken;
        form.capabilitiesStatementFileName = file.fileName;

        this.updatePostData(form, true);
    }

    handleProfessionalAccreditationUploadChange = (file) => {
        let form = this.state.form;
        form.professionalAccreditationStorageToken = file.storageToken;
        form.professionalAccreditationFileName = file.fileName;

        this.updatePostData(form, true);
    }

    downloadFile = (e, storageToken, fileName) => {
        e.preventDefault();
        new SystemAPI().download({
            storageToken: storageToken,
            fileName: fileName
        });
    };

    renderOwners() {
        let me = this;
        let rows = this.state.form.owners.map(function (item, index) {
            return (
                <React.Fragment key={index} >
                    <Row hidden={!(me.state.showMinorityOwners || item.order === 0)} >
                        <Col md={12}><hr /></Col>
                    </Row>
                    <Row hidden={!(me.state.showMinorityOwners || item.order === 0)}>
                        <Col md={4}>
                            <Label>SSN</Label>
                            <div>{item.ownerSSN}&nbsp;</div>
                            <Label>First Name</Label>
                            <div>{item.firstName}&nbsp;</div>
                            <Label>Last Name</Label>
                            <div>{item.lastName}&nbsp;</div>
                            <Label>Title</Label>
                            <div>{item.title}&nbsp;</div>
                        </Col>
                        <Col md={4}>
                            <Label>Military ID Number</Label>
                            <div>{item.militaryIdNumber}&nbsp;</div>
                            <Label>Email Address</Label>
                            <div>{item.email}&nbsp;</div>
                            <Label>Percent of Company Held</Label>
                            <div>{item.companyHeldPercent != null ? item.companyHeldPercent.toLocaleString(navigator.language, { minimumFractionDigits: 2 }) + " %" : ""}&nbsp;</div>
                        </Col>
                        <Col md={4} style={{ textAlign: 'center' }}>
                            {item.isMajorityOwner &&
                                <React.Fragment>
                                    {item.benefitVerificationLetterFileName !== null &&
                                        <React.Fragment>
                                            <div>
												<Button type="button" bsStyle="link" onClick={(e) => me.downloadFile(e, item.benefitVerificationLetterStorageToken, item.benefitVerificationLetterFileName)}>
                                                    Download Benefit Verification Letter
                                                    <br />
                                                    <FontAwesomeIcon icon={faFileAlt} size='3x' color='black' />
												</Button>
                                            </div>
                                            <br />
                                        </React.Fragment>
                                    }
                                    {item.ownerResumeFileName !== null &&
                                        <div>
											<Button type="button" bsStyle="link" onClick={(e) => me.downloadFile(e, item.ownerResumeStorageToken, item.ownerResumeFileName)}>
                                                Download Owner Resume
                                                <br />
                                                <FontAwesomeIcon icon={faFileAlt} size='3x' color='black' />
											</Button>
                                        </div>
                                    }
                                </React.Fragment>
                            }
                        </Col>
                    </Row>
                </React.Fragment>
            )
        });

        return (
            <React.Fragment>
                {rows}
            </React.Fragment>
        );
    }

    renderPointsOfContact() {
        let rows = this.state.form.pointsOfContact.map(function (item, index) {
            return (
                <div key={index}>
                    <Row>
                        <Col md={3}>
                            {item.name}
                        </Col>
                        <Col md={3}>
                            {item.title}
                        </Col>
                        <Col md={6}>
                            {item.email}
                        </Col>
                    </Row>
                </div>
            )
        });

        return (
            <React.Fragment>
                <Row>
                    <Col md={3}>
                        <Label>Name</Label>
                    </Col>
                    <Col md={3}>
                        <Label>Title</Label>
                    </Col>
                    <Col md={6}>
                        <Label>Email</Label>
                    </Col>
                </Row>
                {rows}
            </React.Fragment>
        );
    }

    renderCodes() {
        let rows = this.state.form.naicsCodes.map(function (item, index) {
            return (
                <div key={index}>
                    <Row>
                        <Col md={3}>
                            {item.code}
                        </Col>
                        <Col md={9}>
                            {item.description}
                        </Col>
                    </Row>
                </div>
            )
        });

        return (
            <React.Fragment>
                <Row>
                    <Col md={3}>
                        <Label>NAICS Codes</Label>
                    </Col>
                    <Col md={9}>
                        <Label>NAICS Codes Description</Label>
                    </Col>
                </Row>
                {rows}
            </React.Fragment>
        );
    }

    renderForm() {
        let form = this.state.form;

        const capabilitiesUpload = (
            <Tooltip id="capabilitiesUpload">
                <Row>
                    <Col md={12}>
                        Please ensure that your uploaded documents are in a .txt, Word or PDF format. Please note that uploading scanned documents (.png, .jpeg or PDF) cannot be deciphered by a keyword search
                    </Col>
                </Row>
            </Tooltip>
        );

        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <h3 className="inline">
                            {this.state.form.name} &nbsp;
                            <small>
                                {this.state.form.location}
                            </small>
                        </h3>
                        <div style={{ marginTop: "5px" }}>
                            Doing Business As: <b>{this.state.form.dba ? this.state.form.dbaNames : " - "}</b>
                        </div>
                    </Col>
                </Row>
                <br />
                <hr />
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3>
                                    Company Information&nbsp;–&nbsp;
                                    {form.expirationDate != null ?
                                        <small>
                                            {form.certificationExpDays >= 0 && <React.Fragment>Certification expires on {Formatting.formatDate(form.expirationDate)} ({form.certificationExpDays} days left)&nbsp; </React.Fragment>}
                                            {form.certificationExpDays < 0 && <React.Fragment>Certification expired on {Formatting.formatDate(form.expirationDate)} &nbsp; </React.Fragment>}
                                        </small>
                                    : <small>{this.state.form.generalStatus}</small>
                                    }
                                </h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <Label>Company FEIN/EIN</Label>
                                <div>{form.fein}</div>
                                <Label>Certification Number</Label>
                                <div>{form.certificationNumber}</div>
                            </Col>
                            <Col md={6}>
                                {this.renderCodes()}
                            </Col>
                            <Col md={2} style={{ textAlign: 'center' }}>
                                {false &&
                                    form.isMajorityOwner &&
                                    <React.Fragment>
                                        {form.completedCertificationFileName !== null &&
                                            <div>
												<Button type="button" bsStyle="link" onClick={(e) => this.downloadFile(e, form.completedCertificationStorageToken, form.completedCertificationFileName)} style={{ display: 'block' }}>
                                                    Download Completed Certification Application
                                                	<br />
                                                    <FontAwesomeIcon icon={faFileAlt} size='3x' color='black' />
												</Button>
                                            </div>
                                        }
                                        <br />
                                    </React.Fragment>
                                }
                                {form.certificateFileName !== null &&
                                    <div>
										<Button type="button" bsStyle="link" onClick={(e) => this.downloadFile(e, form.certificateStorageToken, form.certificateFileName)}>
                                            Download Certificate
                                                <br />
                                            <FontAwesomeIcon icon={faFileAlt} size='3x' color='black' />
										</Button>
                                        <br />
                                    </div>
                                }
                                <Button bsStyle='xs' onClick={this.onOnlinePaymentInfoClick}>
                                    <FontAwesomeIcon icon={faInfoCircle} />&nbsp;
                                    Payment Information
                                </Button>
                                <OnlinePaymentInfoPopUp
                                    certificationId={this.state.form.certificationId}
                                    visible={this.state.showOnlinePaymentInfoPopUp}
                                    onClose={this.onOnlinePaymentInfoClose}
                                    onlinePayment={this.state.form.onlinePayment} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3>Owner Details – &nbsp;<small>This is the Primary Contact and Majority Owner of this Company</small></h3>
                            </Col>
                        </Row>
                        {this.renderOwners(true)}
                        {form.owners.length > 1 &&
                            <Row>
                                <Col md={12}>
                                    <br />
									<Button type="button" bsStyle="link" onClick={(e) => this.handleChangeOwnersDisplay(e)}>
                                        {this.state.showMinorityOwners ? "Hide" : "Show"} Minority Owners
									</Button>
                                </Col>
                            </Row>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3>Points of Contact</h3>
                                <hr />
                            </Col>
                        </Row>
                        {this.renderPointsOfContact()}
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3>Capabilities Statement 
                                    <small className="required-indicator"> *</small>
                                </h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={8} style={{ marginTop: '5px' }}>
                                <TextAreaBox required name='capabilitiesStatement' maxLength={10000} rows={4}
                                    placeholder="Please describe your Products and Services. It’s important to note that this statement will be used by Sponsors to match your capabilities with their needs" 
                                    disabled={!form.isMajorityOwner}/>
                            </Col>
                            <Col md={4}>
                                <Label>Capabilities Upload</Label>
                                &nbsp;&nbsp;
                                    <OverlayTrigger placement="right" overlay={capabilitiesUpload}>
                                    <FontAwesomeIcon icon={faInfoCircle} size="1x" className="tooltipIcon" />
                                </OverlayTrigger>
                                <DocumentUpload
                                    disabled={!form.isMajorityOwner}
                                    storageToken={this.state.form.capabilitiesStatementStorageToken}
                                    fileName={this.state.form.capabilitiesStatementFileName}
                                    onChange={this.handleCapabilitiesStatementUploadChange}
                                    wrapFileNameLength={40} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3>Professional Accreditation - <small>Please describe any Certificates or Accreditation your Business holds</small></h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={8} style={{ marginTop: "5px" }}>
                                <TextAreaBox name="professionalAccreditation" maxLength={5000} rows={4} disabled={!form.isMajorityOwner} />
                            </Col>
                            <Col md={4}>
                                <DocumentUpload
                                    disabled={!form.isMajorityOwner}
                                    storageToken={this.state.form.professionalAccreditationStorageToken}
                                    fileName={this.state.form.professionalAccreditationFileName}
                                    onChange={this.handleProfessionalAccreditationUploadChange}
                                    wrapFileNameLength={40} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default ManageCompanyInfoTab;



// WEBPACK FOOTER //
// ./src/areas/companyManagement/manageCompany/manageCompanyInfo/ManageCompanyInfoTab.js